// src\components\Inventory-Stocks & Orders\Admin\StockOrder\OrderInfo\Sidebar.tsx

import React from "react";
import OrderList from "./OrderList";
import { TabType, Order } from "./types";
import Pagination from "../pagination";

interface SidebarProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  medicineOrders: Order[];
  labOrders: Order[];
  onOrderSelect: (order: Order) => void;
  withPrescription: boolean;
  orderStatus: "new" | "awaiting" | "approved";
  selectedOrder: Order | null;
  totalCount:number;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  activeTab,
  medicineOrders,
  labOrders,
  onOrderSelect,
  withPrescription,
  orderStatus,
  selectedOrder,
  currentPage,
  totalPages,
  onPageChange,
  totalCount,
}) => {
  console.log("All Medicine Orders:", medicineOrders);
  console.log("All Lab Orders:", labOrders);
  console.log("Current Filters:", { withPrescription, orderStatus });
  console.log("total pages", totalPages)
  console.log("total items", totalCount)

const currentOrders = activeTab === 'medicine' ? medicineOrders : labOrders;

  return (
    <>
      <div className="flex flex-col">
        <div className="overflow-y-auto max-h-[500px]"
          style={{
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",
          }}
        >
          <OrderList
            activeTab={activeTab}
            orders={currentOrders}
            type={activeTab}
            onOrderClick={onOrderSelect}
            selectedOrder={selectedOrder}
            withPrescription={withPrescription}
            orderStatus={orderStatus}
            isLoading={false}
          />
        </div>

        <div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            totalCount={totalCount}
          />
        </div>
      </div>
    </>
  );
};

export default Sidebar;
